import { AddReferenceComponent } from './add-reference.component';
import { ButtonComponent } from './button.component';
import { CheckboxComponent } from './checkbox.component';
import { CheckboxesComponent } from './checkboxes.component';
import { FileComponent } from './file.component';
import { HiddenComponent } from './hidden.component';
import { InputComponent } from './input.component';
import { MessageComponent } from './message.component';
import { NoneComponent } from './none.component';
import { NumberComponent } from './number.component';
import { OneOfComponent } from './one-of.component';
import { RadiosComponent } from './radios.component';
import { RootComponent } from './root.component';
import { SectionComponent } from './section.component';
import { SelectComponent } from './select.component';
import { SelectFrameworkComponent } from './select-framework.component';
import { SelectWidgetComponent } from './select-widget.component';
import { SubmitComponent } from './submit.component';
import { TabComponent } from './tab.component';
import { TabsComponent } from './tabs.component';
import { TemplateComponent } from './template.component';
import { TextareaComponent } from './textarea.component';

export const BASIC_WIDGETS = [
  AddReferenceComponent, OneOfComponent, ButtonComponent, CheckboxComponent,
  CheckboxesComponent, FileComponent, HiddenComponent, InputComponent,
  MessageComponent, NoneComponent, NumberComponent, RadiosComponent,
  RootComponent, SectionComponent, SelectComponent, SelectFrameworkComponent,
  SelectWidgetComponent, SubmitComponent, TabComponent, TabsComponent,
  TemplateComponent, TextareaComponent
];

export { AddReferenceComponent } from './add-reference.component';
export { OneOfComponent } from './one-of.component';
export { ButtonComponent } from './button.component';
export { CheckboxComponent } from './checkbox.component';
export { CheckboxesComponent } from './checkboxes.component';
export { FileComponent } from './file.component';
export { HiddenComponent } from './hidden.component';
export { InputComponent } from './input.component';
export { MessageComponent } from './message.component';
export { NoneComponent } from './none.component';
export { NumberComponent } from './number.component';
export { OrderableDirective } from './orderable.directive';
export { RadiosComponent } from './radios.component';
export { RootComponent } from './root.component';
export { SectionComponent } from './section.component';
export { SelectComponent } from './select.component';
export { SelectFrameworkComponent } from './select-framework.component';
export { SelectWidgetComponent } from './select-widget.component';
export { SubmitComponent } from './submit.component';
export { TabComponent } from './tab.component';
export { TabsComponent } from './tabs.component';
export { TemplateComponent } from './template.component';
export { TextareaComponent } from './textarea.component';
export { WidgetLibraryService } from './widget-library.service';
